import { Col, Row, Tabs } from "antd";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import SectionHeader from "../../molecules/SectionHeader";
import { CommunicationUtils } from "./utis";

const Communication = (props: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const { updateTab, defaultActiveKey, handleTabChange, itemsCreator, ITEMS } =
    CommunicationUtils();
    console.log("ITEMS",ITEMS);
    

  useEffect(() => {
    const updatedTabParam = updateTab(tab);
    setSearchParams({ tab: updatedTabParam });
    itemsCreator();
  }, []);

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <SectionHeader
            heading="Communication"
            noBorder={true}
            searchName="Category"
            justifiedItems={true}
            justifyEnd={true}
          />
        </Col>

        <Col span={24}>
        {ITEMS && ITEMS.length && (
            <Tabs
              activeKey={defaultActiveKey}
              type="line"
              items={ITEMS}
              onChange={(e) => handleTabChange(e, setSearchParams)}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default Communication;
